import React from "react";
import QCLogo from "../../assets/images/qc-logo.png";
import "./OPPrint.scss";
import { API, graphqlOperation, Auth } from "aws-amplify";
import { getCreateOrderOfBilling } from "../../graphql/queries";
import numberToWords from "number-to-words";
import VELASCOMichael from "../../images/Michael_V_Velazco_OIC_ZAU.png";
import MARIANOMARLON from "../../images/Marlon_G_Mariano_Project_Dept_Officer_IV_ZAU.png";
import JesseZamora from "../../images/Jesse_Zamora_Project_AIDE_Billing_Staff_ZAU.png";
import JOSEEDGARDOGOMEZ from "../../images/Jose_Edgardo_Gomez_JR.png";
import JenConception from "../../images/engrJenConception.png";
import Hermilia_Campos_Banayat from "../../images/Hermilia_Campos_Banayat.png";
import Julia from "../../images/juli1.png";

import Swal from "sweetalert2";

const url = new URL(window.location.href);
const this_id = url.searchParams.get("id");

class OPPrint extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      application: [],
      applicationNo: "",
      projectActivity: "",
      lc_No: "",
      lotno: "",
      blkno: "",
      locationstreet: "",
      locationbarangay: "",
      locationdistrict: "",
      zoneclassification: "",
      owner: "",
      lot_area: "",
      floor_area: "",
      noofunits: "",
      tctno: "",
      evaluationfacts: "",
      OrNumber: "",
      OrDate: "",
      address: "",
      application_zone: [],
      grandTotal: 0,
      grandTotalCents: 0,
      billingOfficer: "",
      dataArchitectural: [],
      addtl_detail: {},
      lot_location: "",
      project_name: "",
      approver: {
        name: "",
        email: "",
        date_final_appr: "",
        position_title: "",
      },
      paymentAmount: 0,
      finalComputation: 0,
      billingOfficerSign: "",
      checklist: [],
      payitem: [],
      order_payment_no: "",
      application_type: "",
      occupancy: "",
      status: "",
      typeofapplication: "",
      approverName: "",
    };
  }

  componentDidMount() {
    try {
      const fetchLocation = async () => {
        const userData = await Auth.currentAuthenticatedUser();

        if (!userData) {
          Swal.fire({
            title: "Not Logged In",
            text: "Please log in to access the user profile.",
            icon: "warning",
            confirmButtonText: "OK",
          }).then(() => {
            localStorage.clear();
            window.location.reload();
          });
        }

        const result = await API.graphql(
          graphqlOperation(getCreateOrderOfBilling, { id: this_id })
        );

        this.setState((prev) => {
          const newState = { ...prev };
          const {
            application_no,
            project_activity,
            lcNo,
            lot_no,
            blk_no,
            location_street,
            location_barangay,
            location_district,
            zone_classification,
            owner,
            lot_area,
            floor_area,
            no_of_units,
            tct_no,
            evaluation_facts,
            Payitem,
            grandTotal,
            grandTotalCents,
            address,
            order_payment_no,
            application_type,
            billing_officer,
            OrNumber,
            OrDate,
            occupancy,
            status,
            typeofapplication,
            nameofapprover5,
          } = result.data.getCreateOrderOfBilling;
          newState.applicationNo = application_no;
          newState.projectActivity = project_activity;
          newState.lc_No = lcNo;
          newState.lotno = lot_no;
          newState.blkno = blk_no;
          newState.locationstreet = location_street;
          newState.locationbarangay = location_barangay;
          newState.locationdistrict = location_district;
          newState.zoneclassification = zone_classification;
          newState.lotarea = lot_area;
          newState.owner = owner;
          newState.floorarea = floor_area;
          newState.noofunits = no_of_units;
          newState.tctno = tct_no;
          newState.evaluationfacts = evaluation_facts;
          newState.payitem = JSON.parse(Payitem);
          newState.grandTotal = grandTotal;
          newState.grandTotalCents = grandTotal.split(".").slice(1);
          newState.address = address;
          newState.order_payment_no = order_payment_no;
          newState.application_type = application_type;
          newState.billingOfficer = billing_officer;
          newState.OrNumber = OrNumber;
          newState.OrDate = OrDate;
          newState.occupancy = occupancy;
          newState.status = status;
          newState.typeofapplication = typeofapplication;
          newState.approverName = nameofapprover5;
          return newState;
        });
      };
      fetchLocation();
    } catch (error) {
      console.log(error);
    }
  }

  downloadThis() {
    document.getElementById("printOption").style.visibility = "hidden";
    document.getElementById("divToPrint").style.marginTop = "-30px";
    window.print();
    document.getElementById("printOption").style.visibility = "visible";
    document.getElementById("divToPrint").style.marginTop = "30px";
  }

  render() {
    const {
      applicationNo,
      projectActivity,
      payitem,
      owner,
      floorarea,
      grandTotal,
      grandTotalCents,
      address,
      order_payment_no,
      application_type,
      billingOfficer,
      lc_No,
      lotno,
      blkno,
      locationstreet,
      locationbarangay,
      locationdistrict,
      occupancy,
      status,
      typeofapplication,
      approverName,
    } = this.state;

    return (
      <>
        {(status === "6" ||
          status === "5" ||
          status === "4" ||
          status === "1") && (
          <>
            <div
              className="container-fluid noprint hidden-print"
              id="printOption"
            >
              <div className="row">
                <button
                  onClick={this.downloadThis}
                  className="btn btn-primary btn-block"
                >
                  Print
                </button>
              </div>
            </div>

            <div className="AEP_OPP fw-bold" id="divToPrint">
              <div className="row">
                <div className="col">
                  <div className="mx-auto op-fs">
                    OP NO# {order_payment_no && order_payment_no}
                  </div>
                </div>

                <div className="col">
                  <div className="row">
                    <div className="col-6"></div>
                    <div className="col">
                      <div className="row">
                        <span className="mr-5">Application No.:</span>{" "}
                        <span>{applicationNo && applicationNo}</span>
                      </div>
                      <div className="row">
                        <span className="mr-5">Application Type:</span>{" "}
                        <span>
                          {application_type && application_type.toUpperCase()}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="AEP-header">
                <img className="qc-logo" src={QCLogo} alt="qc-logo" />
                <div className="qc-header">
                  <p>Republika ng Pilipinas</p>
                  <p>Quezon City</p>
                  <p>CITY PLANNING AND DEVELOPMENT OFFICE</p>
                  <p>Zoning Administration Unit</p>
                </div>
              </div>

              <div className="text-uppercase text-center title-fs mb-2">
                <u>Order of Payment</u>
              </div>

              <div className="row">To the City Treasurer:</div>

              <div className="row">
                <div>Please collect from Mr/Ms:</div>
                <div className="blank-space text-center">
                  {owner.toUpperCase()}
                </div>
              </div>

              <div className="row mb-2">
                <div>With address at:</div>
                <div className="blank-space text-center">
                  {typeofapplication === "COE"
                    ? address
                    : `${lotno !== "-" ? "LOT " + lotno : ""} ${
                        blkno !== "-" ? "BLK " + blkno : ""
                      } ${locationstreet} BRGY. ${locationbarangay} ${locationdistrict} QUEZON CITY`}
                </div>
              </div>

              <div className="row text-justify mb-2">
                <span style={{ textIndent: "30px" }}>
                  The following fees indicated below is being assessed pursuant
                  of Ordinance SP-2502, S-2016 otherwise known as the Revised
                  Quezon City Comprehensive Zoning Ordinance (Series of 2016)
                </span>
              </div>

              <div className="row mb-1">
                <span>PROJECT ACTIVITY:</span>
                <div className="blank-space text-center">
                  {projectActivity && projectActivity}
                </div>
              </div>

              <div className="row mb-1">FEES:</div>

              <div className="row">
                <div className="col mb-2">
                  {payitem.map((item) => (
                    <>
                      {item && item.paymentitem !== "" && (
                        <div className="row" style={{ marginBottom: "-10px" }}>
                          <div className="col">
                            {item.paymentitem}
                            <div className="row">
                              <div className="col-8">
                                {item.paymentitem ===
                                  "Zoning - Processing Fee" &&
                                  typeofapplication !== "COE" &&
                                  typeofapplication !== "LCSUP" && (
                                    <p className="inline-p ml-5">
                                      Total FLOOR AREA of the Project{" "}
                                      <span className="styled-underline-blank-smallest">
                                        {floorarea && floorarea}
                                      </span>{" "}
                                      sq. mts. X{" "}
                                      {occupancy === "2"
                                        ? "10.00"
                                        : occupancy === "4"
                                        ? "150.00"
                                        : occupancy === "3"
                                        ? "7.5.00"
                                        : occupancy === "5"
                                        ? "8.00"
                                        : occupancy === "6"
                                        ? "150.00"
                                        : occupancy === "7"
                                        ? "150.00"
                                        : occupancy === "1"
                                        ? "3.00"
                                        : `${occupancy}.00`}
                                    </p>
                                  )}
                              </div>
                              <div className="col d-flex justify-content-end">
                                <span>₱ </span>
                                <span className="styled-underline-blank-regular text-right">
                                  {parseFloat(item.total)
                                    .toFixed(2)
                                    .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </>
                  ))}
                </div>
              </div>

              <div className="row">
                <div className="col-9 d-flex">
                  <div className="mr-auto">AMOUNT IN WORDS:</div>
                  <div className="blank-space text-center">
                    {`${numberToWords
                      .toWords(grandTotal)
                      ?.toUpperCase()} PESOS ${
                      grandTotalCents !== "00"
                        ? "AND " +
                          numberToWords
                            .toWords(grandTotalCents)
                            ?.toUpperCase() +
                          " CENTAVOS"
                        : ""
                    }`}
                  </div>
                </div>

                <div className="col d-flex justify-content-end">
                  <span>₱ </span>
                  <span className="styled-underline-blank-regular text-right">
                    {parseFloat(grandTotal).toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </span>
                </div>
              </div>

              <div className="row d-flex" style={{ marginTop: -20 }}>
                <div className="col">
                  <div className="mr-auto text-center empty-width">
                    <img
                      src={
                        billingOfficer === "Jesse  J Zamora"
                          ? JesseZamora
                          : Julia
                      }
                      className="signaturePrint image-height img-fluid"
                      alt="Billing Officer Signature"
                    />
                    <div style={{ marginTop: "-40px" }}>
                      <div className="text-center mb-1">
                        {billingOfficer.toLocaleUpperCase()}
                      </div>
                      <div
                        className="row text-center font-weight-bold mb-1"
                        style={{ borderTop: "1px solid #333" }}
                      />
                      <div className="text-center">BILLING STAFF</div>
                    </div>
                  </div>
                </div>

                <div className="col">
                  <div className="ml-auto text-center empty-width">
                    <img
                      src={MARIANOMARLON}
                      className="signaturePrint image-height img-fluid"
                      alt="Recommending Approval Signature"
                    />
                    <div style={{ marginTop: "-40px" }}>
                      <div className="text-center mb-1">MARLON MARIANO</div>
                      <div
                        className="row text-center font-weight-bold mb-1"
                        style={{ borderTop: "1px solid #333" }}
                      />
                      <div className="text-center">RECOMMENDING APPROVAL</div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row" style={{ marginTop: -20 }}>
                <div className="col">
                  <div className="mr-auto text-center empty-width">
                    <div style={{ marginTop: "84px" }}>
                      <div className="text-center mb-1"></div>
                      <div
                        className="row text-center font-weight-bold mb-1"
                        style={{ borderTop: "1px solid #333" }}
                      />
                      <div className="text-center">CASHIER</div>
                    </div>
                  </div>
                </div>

                <div className="col">
                  <div className="ml-auto text-center empty-width">
                    <img
                      src={
                        approverName === "Michael B Velasco"
                          ? VELASCOMichael
                          : approverName === "Jose Edgardo A Gomez, JR"
                          ? JOSEEDGARDOGOMEZ
                          : approverName === "Hermilia Campos Banayat"
                          ? Hermilia_Campos_Banayat
                          : JenConception
                      }
                      className="signaturePrint image-height img-fluid"
                      alt="OIC Signature"
                    />
                    <div style={{ marginTop: "-40px" }}>
                      <div className="text-center mb-1">
                        {approverName === "Michael B Velasco"
                          ? "MR. MICHAEL B. VELASCO"
                          : approverName === "Jose Edgardo A Gomez, JR"
                          ? "DR. JOSE EDGARDO A GOMEZ, JR."
                          : approverName === "Hermilia Campos Banayat"
                            ? "HERMILIA CAMPOS BANAYAT"
                            : "JENNIFER G. CONCEPCION"}
                      </div>
                      <div
                        className="row text-center font-weight-bold mb-1"
                        style={{ borderTop: "1px solid #333" }}
                      />
                      <div className="text-center">
                        {approverName === "Hermilia Campos Banayat"
                          ? "Secretary to the Mayor, Office of the Secretary to the Mayor,"
                          : "OIC - ZONING ADMINISTRATION UNIT"}
                      </div>
                      {approverName === "Hermilia Campos Banayat" && (
                        <div className="text-center">
                          Officer-in-Charge, Zoning Administration Unit
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div className="row d-flex justify-content-end mt-2">
                QCG-CPDO-BLP-Form 08-V.01
              </div>

              <hr style={{ borderTop: "dotted 1px", marginBottom: "1rem" }} />

              <div className="row">
                <div className="col">
                  <div className="mx-auto op-fs">
                    OP NO# {order_payment_no && order_payment_no}
                  </div>
                </div>

                <div className="col">
                  <div className="row">
                    <div className="col-6"></div>
                    <div className="col">
                      <div className="row">
                        <span className="mr-5">Application No.:</span>{" "}
                        <span>{applicationNo && applicationNo}</span>
                      </div>
                      <div className="row">
                        <span className="mr-5">Application Type:</span>{" "}
                        <span>
                          {application_type && application_type.toUpperCase()}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="AEP-header">
                <img className="qc-logo" src={QCLogo} alt="qc-logo" />
                <div className="qc-header">
                  <p>Republika ng Pilipinas</p>
                  <p>Quezon City</p>
                  <p>CITY PLANNING AND DEVELOPMENT OFFICE</p>
                  <p>Zoning Administration Unit</p>
                </div>
              </div>

              <div className="text-uppercase text-center title-fs mb-2">
                <u>Order of Payment</u>
              </div>

              <div className="row">To the City Treasurer:</div>

              <div className="row">
                <div>Please collect from Mr/Ms:</div>
                <div className="blank-space text-center">
                  {owner.toUpperCase()}
                </div>
              </div>

              <div className="row mb-2">
                <div>With address at:</div>
                <div className="blank-space text-center">
                  {typeofapplication === "COE"
                    ? address
                    : `${lotno !== "-" ? "LOT " + lotno : ""} ${
                        blkno !== "-" ? "BLK " + blkno : ""
                      } ${locationstreet} BRGY. ${locationbarangay} ${locationdistrict} QUEZON CITY`}
                </div>
              </div>

              <div className="row text-justify mb-2">
                <span style={{ textIndent: "30px" }}>
                  The following fees indicated below is being assessed pursuant
                  of Ordinance SP-2502, S-2016 otherwise known as the Revised
                  Quezon City Comprehensive Zoning Ordinance (Series of 2016)
                </span>
              </div>

              <div className="row mb-1">
                <span>PROJECT ACTIVITY:</span>
                <div className="blank-space text-center">
                  {projectActivity && projectActivity}
                </div>
              </div>

              <div className="row mb-1">FEES:</div>

              <div className="row">
                <div className="col mb-2">
                  {payitem.map((item) => (
                    <>
                      {item && item.paymentitem !== "" && (
                        <div className="row" style={{ marginBottom: "-10px" }}>
                          <div className="col">
                            {item.paymentitem}
                            <div className="row">
                              <div className="col-8">
                                {item.paymentitem ===
                                  "Zoning - Processing Fee" &&
                                  typeofapplication !== "COE" && (
                                    <p className="inline-p ml-5">
                                      Total FLOOR AREA of the Project{" "}
                                      <span className="styled-underline-blank-smallest">
                                        {floorarea && floorarea}
                                      </span>{" "}
                                      sq. mts. X{" "}
                                      {occupancy === "2"
                                        ? "10.00"
                                        : occupancy === "4"
                                        ? "150.00"
                                        : occupancy === "3"
                                        ? "7.5.00"
                                        : occupancy === "5"
                                        ? "8.00"
                                        : occupancy === "6"
                                        ? "150.00"
                                        : occupancy === "7"
                                        ? "150.00"
                                        : occupancy === "1"
                                        ? "3.00"
                                        : `${occupancy}.00`}
                                    </p>
                                  )}
                              </div>
                              <div className="col d-flex justify-content-end">
                                <span>₱ </span>
                                <span className="styled-underline-blank-regular text-right">
                                  {parseFloat(item.total)
                                    .toFixed(2)
                                    .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </>
                  ))}
                </div>
              </div>

              <div className="row">
                <div className="col-9 d-flex">
                  <div className="mr-auto">AMOUNT IN WORDS:</div>
                  <div className="blank-space text-center">
                    {`${numberToWords
                      .toWords(grandTotal)
                      ?.toUpperCase()} PESOS ${
                      grandTotalCents !== "00"
                        ? "AND " +
                          numberToWords
                            .toWords(grandTotalCents)
                            ?.toUpperCase() +
                          " CENTAVOS"
                        : ""
                    }`}
                  </div>
                </div>

                <div className="col d-flex justify-content-end">
                  <span>₱ </span>
                  <span className="styled-underline-blank-regular text-right">
                    {parseFloat(grandTotal).toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </span>
                </div>
              </div>

              <div className="row d-flex" style={{ marginTop: -20 }}>
                <div className="col">
                  <div className="mr-auto text-center empty-width">
                    <img
                      src={
                        billingOfficer === "Jesse  J Zamora"
                          ? JesseZamora
                          : Julia
                      }
                      className="signaturePrint image-height img-fluid"
                      alt="Billing Officer Signature"
                    />
                    <div style={{ marginTop: "-40px" }}>
                      <div className="text-center mb-1">
                        {billingOfficer.toLocaleUpperCase()}
                      </div>
                      <div
                        className="row text-center font-weight-bold mb-1"
                        style={{ borderTop: "1px solid #333" }}
                      />
                      <div className="text-center">BILLING STAFF</div>
                    </div>
                  </div>
                </div>

                <div className="col">
                  <div className="ml-auto text-center empty-width">
                    <img
                      src={MARIANOMARLON}
                      className="signaturePrint image-height img-fluid"
                      alt="Recommending Approval Signature"
                    />
                    <div style={{ marginTop: "-40px" }}>
                      <div className="text-center mb-1">MARLON MARIANO</div>
                      <div
                        className="row text-center font-weight-bold mb-1"
                        style={{ borderTop: "1px solid #333" }}
                      />
                      <div className="text-center">RECOMMENDING APPROVAL</div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row" style={{ marginTop: -20 }}>
                <div className="col">
                  <div className="mr-auto text-center empty-width">
                    <div style={{ marginTop: "84px" }}>
                      <div className="text-center mb-1"></div>
                      <div
                        className="row text-center font-weight-bold mb-1"
                        style={{ borderTop: "1px solid #333" }}
                      />
                      <div className="text-center">CASHIER</div>
                    </div>
                  </div>
                </div>

                <div className="col">
                  <div className="ml-auto text-center empty-width">
                    <img
                      src={
                        approverName === "Michael B Velasco"
                          ? VELASCOMichael
                          : approverName === "Jose Edgardo A Gomez, JR"
                          ? JOSEEDGARDOGOMEZ
                          : approverName === "Hermilia Campos Banayat"
                          ? Hermilia_Campos_Banayat
                          : JenConception
                      }
                      className="signaturePrint image-height img-fluid"
                      alt="OIC Signature"
                    />
                    <div style={{ marginTop: "-40px" }}>
                      <div className="text-center mb-1">
                        {approverName === "Michael B Velasco"
                          ? "MR. MICHAEL B. VELASCO"
                          : approverName === "Jose Edgardo A Gomez, JR"
                          ? "DR. JOSE EDGARDO A GOMEZ, JR."
                          : approverName === "Hermilia Campos Banayat"
                            ? "HERMILIA CAMPOS BANAYAT"
                            : "JENNIFER G. CONCEPCION"}
                      </div>
                      <div
                        className="row text-center font-weight-bold mb-1"
                        style={{ borderTop: "1px solid #333" }}
                      />
                      <div className="text-center">
                        {approverName === "Hermilia Campos Banayat"
                          ? "Secretary to the Mayor, Office of the Secretary to the Mayor,"
                          : "OIC - ZONING ADMINISTRATION UNIT"}
                      </div>
                      {approverName === "Hermilia Campos Banayat" && (
                        <div className="text-center">
                          Officer-in-Charge, Zoning Administration Unit
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div className="row d-flex justify-content-end mt-2">
                QCG-CPDO-BLP-Form 08-V.01
              </div>
            </div>
          </>
        )}
      </>
    );
  }
}

export default OPPrint;
